<template>
  <div class="chart" :class="{ small: isSmall }">
    <header>
      <h2>
        <span>
          Fossiilkütuste asendamiseks vajalik mittefossiilkütustel toodetud
          elektrienergia
        </span>
      </h2>
    </header>

    <main>
      <div class="row-wrapper table-header border-bottom">
        <div>Sektor</div>
        <div>Valdkond</div>
        <div style="text-align: right">
          Täiendav elektrivajadus <br />
          (TWh aastas)
        </div>
      </div>

      <div class="row-wrapper">
        <div class="sektor">Transport</div>
        <div></div>
        <div></div>
      </div>

      <div class="row-wrapper">
        <div></div>
        <div>Elektritransport</div>
        <div class="number">6 158,4</div>
      </div>

      <div class="row-wrapper border-bottom">
        <div></div>
        <div>Vesinikkütuse tootmiseks</div>
        <div class="number">11 553,6</div>
      </div>

      <div class="row-wrapper">
        <div class="sektor">Fossiilkütuste asendamine elektri tootmisel</div>
        <div></div>
        <div></div>
      </div>

      <div class="row-wrapper">
        <div></div>
        <div>Kivisüsi, pruunsüsi</div>
        <div class="number">9 421,4</div>
      </div>

      <div class="row-wrapper">
        <div></div>
        <div>Maagaas</div>
        <div class="number">6 268,1</div>
      </div>

      <div class="row-wrapper">
        <div></div>
        <div>Hoonete gaasiküte</div>
        <div class="number">2 560</div>
      </div>

      <div class="row-wrapper border-bottom">
        <div></div>
        <div>Õli</div>
        <div class="number">758</div>
      </div>

      <div class="row-wrapper border-bottom">
        <div class="sektor">Metallurgia, plastitootmine, keemia</div>
        <div></div>
        <div class="number">951,1</div>
      </div>

      <div class="row-wrapper table-summary">
        <div>KOKKU</div>
        <div></div>
        <div class="number">37 670,6</div>
      </div>
    </main>
  </div>
</template>

<style scoped>
.chart {
  --section-color: #0064fa;
  --section-secondary-color: #0000ba;
  --section-tertiary-color: #a5e6e9;
  --line: #d5d8dd;
  --gray: #717c8e;
  --lightest: #eef3f6;
  --text-color: #262626;

  width: 100%;
  display: flex;
  flex-direction: column;

  position: relative;

  font-family: GT Eesti, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  color: var(--text-color);
  line-height: 1;

  font-size: 16px;
}

.chart.small {
  font-size: 12px;
}

header > h2 {
  font-size: 1.5em !important;
  line-height: 1.15 !important;
  margin: 0 !important;

  display: grid;
  grid-template-columns: 5fr 2fr;
  align-items: center;

  gap: 1ch;
}

header > h2:after {
  content: "";
  color: var(--line);

  height: 12px;
  width: 100%;
  background-image: radial-gradient(
    circle at 1px 1px,
    currentColor 1px,
    transparent 0
  );
  background-size: 4px 4px;
  user-select: none;
  pointer-events: none;
}

main {
  margin-top: 1em;
  width: 100%;

  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: min-content;

  line-height: 1.15;
}

.row-wrapper {
  display: contents;
}

.row-wrapper > div {
  padding: 0.25em 0;
}

.table-header > div {
  font-weight: 300;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.border-bottom > div {
  border-bottom: 1px dotted var(--line);
}

.number {
  font-size: 1.1em;
  font-weight: 600;

  display: flex;
  align-items: center;
  justify-content: flex-end;

  white-space: nowrap;
}

.number::after {
  content: "TWh";
  margin-left: 1ch;
  font-weight: 300;
}

.table-summary > div {
  font-size: 1.25em;
  font-weight: 700;
}

.sektor {
  font-weight: 700;
}

.row-wrapper:not(.table-header):hover > div {
  background-color: var(--lightest);
}
</style>

<script setup>
import { ref, computed, onMounted, onUnmounted, inject, nextTick } from "vue";

//
const containerElement = inject("containerElement");
const width = ref(0);
const isSmall = ref(false);

// *** methods ***

function onResize() {
  const bounds = containerElement.getBoundingClientRect();
  width.value = bounds.width;
  isSmall.value = bounds.width < 600;
}

// Vue lifecycle

onMounted(() => {
  //
  window.addEventListener("resize", onResize);
  onResize();

  // const htmlElement = document.querySelector("html");
  // const isPhone = htmlElement.classList.contains("device-phone");
  // console.log("is phone", isPhone);
});

onUnmounted(() => {
  window.removeEventListener("resize", onResize);
});
</script>
